import { defineComponent as _defineComponent } from 'vue';
import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/images/providers/allproviders1.png';
import _imports_1 from '../../assets/images/providers/allproviders2.png';
import _imports_2 from '../../assets/images/providers/allproviders3.png';
const _hoisted_1 = { class: "tw-w-fulltw-w-full tw-pt-[calc(85px+1.25rem)]" };
import { ref, computed } from "vue";
import { usePopupStore } from "@/stores/popup";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SideBarProviders',
    props: {
        games: {},
        selectedCategory: {},
        isLoading: { type: Boolean }
    },
    emits: ["viewGames"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const searchQuery = ref("");
        const gameUrl = ref(null);
        const scrollContainer = ref(null);
        // Computed property to filter games based on searchQuery
        const filteredGames = computed(() => {
            return props.games.filter(game => game.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
        });
        const handleGameClick = (game) => {
            if (!localStorage.getItem("user")) {
                usePopupStore().showPopup("login");
                return;
            }
            const url = `https://azurecoinz.com/game/${game.name}?api_exit=/`;
            window.innerWidth < 768 ? window.open(url, "_blank") : (gameUrl.value = url);
        };
        const closeGame = () => (gameUrl.value = null);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
                _createStaticVNode("<div class=\"row\"><div class=\"col-12\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"col-12 tw-pt-2\"><img src=\"" + _imports_1 + "\" alt=\"\"></div><div class=\"col-12 tw-pt-2\"><img src=\"" + _imports_2 + "\" alt=\"\"></div></div>", 1)
            ])));
        };
    }
});
